import React from 'react';
import {CtaButton} from '../cta-button/cta-button';
import LinearText from '../linear-text/linear-text';

interface AnniversarySectionProps {
    content?: string;
    desktopBgUrl?: string;
    mobileBgUrl?: string;
    ctaText?: string;
    onAction?: () => void;
}

const DEFAULT_CONTENT =
    'Trong suốt những năm qua, KidsPlaza đã vinh dự đồng hành cùng Quý khách hàng và Quý đối tác gieo những hạt mầm ý nghĩa cho hàng triệu gia đình Việt. ' +
    'Năm nay, bước sang mùa Festival thứ 10, chúng tôi mang đến phiên bản đặc biệt FESTIVAL TREND – “Cùng con vươn mình - Kiến tạo tương lai”. ' +
    'Không chỉ là một sự kiện thường niên, Festival đã trở thành biểu tượng tiên phong, nơi khởi nguồn những xu hướng nuôi dạy con hiện đại, ' +
    'kết nối Gen Y và Gen Z – những thế hệ cha mẹ đầy khát vọng, tự tin và bản lĩnh.';

const AnniversaryV2: React.FC<AnniversarySectionProps> = ({
    content = DEFAULT_CONTENT,
    desktopBgUrl = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v3/anniversary-desktop-v3.webp',
    mobileBgUrl = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v3/anniversary-mobile-v3.webp',
    ctaText = 'ĐĂNG KÝ FESTIVAL',
    onAction,
}) => {
    return (
        <section id="organization-and-partners" className="relative z-10">
            <div className="w-full overflow-hidden bg-white">
                {/* ============ DESKTOP (2000x1220) ============ */}
                <div
                    className="relative hidden md:block w-full aspect-[2000/1220] bg-cover bg-bottom bg-no-repeat"
                    style={{backgroundImage: `url(${desktopBgUrl})`}}>
                    <svg
                        className="absolute inset-0 w-full h-full"
                        viewBox="0 0 2000 1220"
                        preserveAspectRatio="xMidYMid meet">
                        <foreignObject x="0" y="0" width="2000" height="1220">
                            <div className="w-full h-full flex justify-center items-end pointer-events-auto">
                                <div className="w-[996px] mb-[120px] text-center text-white font-montserrat font-bold px-4">
                                    <p className="text-[18px] leading-[1.55] m-0">{content}</p>

                                    <div className="mt-6 flex justify-center">
                                        <div className="w-[360px] h-[56px] flex items-center justify-center">
                                            <CtaButton
                                                text={ctaText}
                                                className="w-full h-full"
                                                contentClassName="font-bold font-next_roboto text-[22px]"
                                                onClick={onAction}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </foreignObject>
                    </svg>
                </div>

                {/* ============ MOBILE (375x813) ============ */}
                <div
                    className="relative block md:hidden w-full aspect-[375/813] bg-cover bg-bottom bg-no-repeat"
                    style={{backgroundImage: `url(${mobileBgUrl})`}}>
                    <svg
                        className="absolute inset-0 w-full h-full"
                        viewBox="0 0 375 813"
                        preserveAspectRatio="xMidYMid meet">
                        <foreignObject x="0" y="0" width="375" height="813">
                            <div className="w-full h-full flex justify-center items-end pointer-events-auto">
                                <div className="w-[327px] mb-[60px] text-white font-montserrat font-bold text-center">
                                    <p className="text-[13px] [@media(min-width:350px)]:text-[12px] leading-[1.6] m-0">
                                        {content}
                                    </p>

                                    <div className="mt-4 flex justify-center">
                                        <div className="w-[280px] h-[48px] flex items-center justify-center max-w-[280px] max-h-[48px] [@media(min-width:350px)]:w-[224px] [@media(min-width:350px)]:h-[38px]">
                                            <button
                                                aria-label="Khuyến mãi kỷ niệm"
                                                onClick={onAction}
                                                className="px-1 py-1 rounded-full cursor-pointer flex justify-center items-center"
                                                style={{
                                                    background:
                                                        'linear-gradient(290.93deg, #DABA03 18.72%, #FFF04D 37.08%, #FFFDBD 43.79%, #CEAF00 57.39%, #FFFDBD 66.64%, #FFE659 77.01%)',
                                                    //WebkitBackground:'linear-gradient(290.93deg, #DABA03 18.72%, #FFF04D 37.08%, #FFFDBD 43.79%, #CEAF00 57.39%, #FFFDBD 66.64%, #FFE659 77.01%)',
                                                    WebkitTapHighlightColor: 'transparent',
                                                    WebkitTouchCallout: 'none',
                                                    WebkitUserSelect: 'none',
                                                }}>
                                                <div
                                                    className="h-full w-full rounded-full flex justify-center items-center py-2 px-5"
                                                    style={{
                                                        background:
                                                            'linear-gradient(103.28deg, #E6FFFD 1.06%, #F6E989 95.93%)',
                                                    }}>
                                                    <LinearText>{ctaText}</LinearText>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </foreignObject>
                    </svg>
                </div>
            </div>
        </section>
    );
};

export default AnniversaryV2;
